import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogComponent } from '../dialog.component';
import { InfoDialogComponent } from '../info-dialog/info-dialog.component';

@Component({
  selector: 'app-propaganda-dialog',
  templateUrl: './propaganda-dialog.component.html',
  styleUrls: ['./propaganda-dialog.component.css']
})
export class PropagandaDialogComponent extends DialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<InfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    super("", "");
  }

  ngOnInit() {
  }
}
